import React from "react";
import { connect } from "react-redux";
import _ from "lodash";

import SubHeader from "./SubHeader";
import FormSelect from "../forms/FormSelect";
import FormInput from "../forms/FormInput";
import { setLoading } from "../../actions/authAction";
import history from "../../history";
import api from "../../api/api";
import uri from "../../variables/uri";
import AlertModal from '../modals/AlertModal';
import RequestDetailModal from '../modals/RequestDetailModal';
import ActionModal from '../modals/ActionModal';
import HistoryModal from '../modals/HistoryModal';
import ConfirmDialogModal from '../modals/ConfirmDialogModal';
import ReactExport from "react-data-export";
import Pagination from 'rc-pagination';
const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;

class SearchRequestForAdmin extends React.Component {
  state = {
    name: '',
    user: this.props.user,
    isOpenMessage: false,
    isOpenHistory: false,
    isOpenConfirm: false,
    isOpenDetail:false,
    type:1,
    message: "",
    text: "",
    requestNo: "",
    dataList:[],
    currentPage: 1,
    postsPerPage: 15,
    detailList:[],
    permissionList:[],
    isOpenGroup:false,
    bookName:'',
    isDownloadExcel:false,
    excelDataList:[],
    excelRequestId:'',
    excelRequestNo:'',
    excelRequestDate:'',
    excelRequestUserId:'',
    isOpenAction:false,
    action:'',
    actionId:'',
    historyList:[],
    selectedRequestIds:[],
    isMass:false,
    isCheckedAll:false,
    status:'',
    statusArr:[],
    statusList:[],
    statusSelected:{},
    fileName:'',
  };

  componentDidMount = async () => { 
    if (!this.props.auth.isAuthen || (!this.props.auth.isAdmin)) {
      history.push(`/home/${localStorage.getItem('username')}`)
    }
    else {
      this.getStatus();
      this.onSearch();
    }
  };
 
  onRequestNoChange = (val) => {
    this.setState({ requestNo:val});
  };

  onNameChange = (name) => {
    this.setState({ name });
  };

  onStatusChange =(status)=>{
    const found = this.state.statusList.find(
      (item) => item.Name === status
    );
    this.setState({ status,statusSelected:found });
  };

  getStatus = async ()=>{
    try{
      const response = await api.get(`${uri.GET_STATUS}`);
      if (response.status === 200) {
          const statusArr = ["All"];
          statusArr.push();
              response.data.forEach((item) => {
                statusArr.push(item.Name);
            
          });
          this.setState({
            statusList: response.data,
            statusArr: statusArr
          });
      }
    }
    catch(ex){
      this.setState({
        dataList: [],
      });
    }
  }

  onSearch = async () => {
    this.props.setLoading(true);
    try{
      let param = '';
      if(this.state.statusSelected !== undefined){
        if(this.state.statusSelected.Code !== undefined){
          param += this.state.statusSelected.Code;
        }
    }
      const groupResponse = await api.get(
        `${uri.GET_SEARCH_REQUEST_ADMIN}?search=${this.state.requestNo}&status=${param}&user=${this.state.name}`
      );
    if (groupResponse.status === 200) {
        this.setState({
          dataList: groupResponse.data,
          currentPage:1
        });
        this.props.setLoading(false);
        this.updateSelectedRequest();
      }
    }catch(ex){
      this.setState({
        dataList: [],
      });
      this.props.setLoading(false);
    }
  };

  onDetail = async (id) => {
    this.props.setLoading(true);
    try{
      var response = await api.get(
        `${uri.GET_REQUEST_DETAIL}?id=${id}`
      );
      if(response.status === 200){
        
        const permis = await api.get(`${uri.GET_PERMISSION_LIST}?PermissionGroupID=${ response.data.PermissionGroupId}`);
        const permissionArr = [];
        permis.data.forEach(element => {
            permissionArr.push(element.PermissionName !== null ? element.PermissionName : element.PermissionValue);
        });
        let permissionSelection = permissionArr;
        permissionSelection.push('Please select');
        permissionSelection = permissionSelection.reverse();
        this.setState({isOpenDetail:true,detailList:response.data.Details, bookName: response.data.BookName , permissionList:_.sortBy(permis.data, 'PermissionSequence').reverse()});
        this.props.setLoading(false);
      }
    }catch(ex){
      console.log(ex);
      this.setState({isOpenDetail:false,detailList:[],isOpenMessage: true, message:"Data not found.", type:3});
      this.props.setLoading(false);
    }
  }

  handleCheckboxAllChange = (e) =>{
    let checkedList =[];
    let newCheckedList = this.state.dataList.map(obj => {
      if(obj.StatusCode !== 'complete' && obj.StatusCode !== 'cancel' && obj.StatusCode !== 'reject'){
        obj.IsChecked = e.target.checked
        if(obj.IsChecked === true){
          checkedList.push(obj.RequestID);
        }
      }
      return obj
    });
    this.setState({dataList:newCheckedList,isCheckedAll:e.target.checked,selectedRequestIds:checkedList});
  }

  handleCheckboxChange = (e,key)=>{
    let checkedList =[];
    let newCheckedList = this.state.dataList.map(obj => {
        if(obj.RequestID === key){
            obj.IsChecked = e.target.checked
            if(obj.IsChecked === true){
              checkedList.push(obj.RequestID);
            }
            return obj
        }else{
            if(obj.IsChecked === true){
              checkedList.push(obj.RequestID);
            }
            return obj
        }
    });
    this.setState({dataList:newCheckedList,selectedRequestIds:checkedList});
  }

  updateSelectedRequest(){
    let checkedList =[];
    this.state.dataList.map(obj => {
        if(obj.IsChecked === true){
          checkedList.push(obj.RequestID);
        }
        return obj
    });
    this.setState({selectedRequestIds:checkedList});
  }

  onUnlock = async ()=>{
    try{
      this.props.setLoading(true);
      var reqData = [];
      if(this.state.isMass){
        reqData = this.state.selectedRequestIds;
      }else{
        reqData = [this.state.selectedRequestId];
      }
      var obj = {
        Action:"cancel",
        Reason:"Cancel by Admin",
        UserId:localStorage.getItem('username'),
        RequestIDs: reqData
      }
      var response = await api.post(uri.POST_MULTI_ACTION,obj);
      if(response.status === 200){
        this.setState({ isOpenMessage: true, isOpenConfirm:false,message:"Success",type:1});
        this.onSearch();
        this.props.setLoading(false);
      }
    }catch(ex){
      this.setState({ isOpenMessage: true, isOpenConfirm:false,message:"An error has occurred",type:3});
      this.props.setLoading(false);
    }
    
  }

  displayNote=(txt)=>{

    if(txt !== null && txt !== undefined && txt !== ""){
      if(txt.length > 20){
        txt = txt.substring(0, 20)+"...";
      }
      return (<span>{txt}</span>)
    }
    return (<span></span>)
  }

  onConfirmUnlock = (requestId)=>{
    this.setState({ isMass:false, selectedRequestId:requestId, isOpenConfirm:true, text:'Do you want to cancel the request?', message:'Cancel request'});
  }

  onConfirmMassUnlock =()=>{
    if(this.state.selectedRequestIds.length === 0){
      this.setState({ isOpenMessage:true, message:'Please select request.',type:2});
    }else{
      this.setState({ isMass:true, isOpenConfirm:true, text:'Do you want to cancel the request?', message:'Cancel request'});
    }
  }

  onClose = () =>{
    this.setState({ isOpenDetail: false, isOpenMessage: false, isOpenConfirm:false, isOpenAction:false, isOpenHistory: false});
  }

  onHistory = async (id)=>{
    this.props.setLoading(true);
    try{
      var response = await api.get(
        `${uri.GET_HISTORY}?id=${id}`
      );
    if(response.status === 200){
      this.setState({ isOpenHistory:true, historyList: response.data});
      this.props.setLoading(false);
    }
    }catch(ex){
      this.setState({isOpenHistory:false,historyList:[]});
      this.props.setLoading(false);
    }
  }

  onAction =(id,act)=>{
    this.setState({ actionId:id, action: act, isOpenAction:true});
  }

  onConfirmAction = async (txt)=>{
    this.onClose();
    this.props.setLoading(true);
    try{
      var obj = {
        RequestID:this.state.actionId,
        Action:this.state.action,
        Reason:txt,
        UserId:localStorage.getItem('username')
      }
      var response = await api.post(`${uri.POST_ACTION}`,obj);
      if(response.status === 200){
        this.setState({ isOpenMessage: true, message:'The request has been '+this.state.action, type:1});
        this.props.setLoading(false);
        this.onSearch();
      }

    }catch(ex){
      this.setState({ isOpenMessage: true, message:ex.Message, type:3});
      this.props.setLoading(false);
    }
  }

  convertNullToStringEmpty(str){
    if(str === undefined || str === null){
        return "";
    }else{
        return str;
    }
  } 

  onDownloadCheckin= async (id,rno,rdate,ruser)=>{
    this.setState({ isDownloadExcel:false});
    this.props.setLoading(true);
    try{
      var response = await api.get(
        `${uri.GET_REQUEST_DETAIL}?id=${id}`
      );
    if(response.status === 200){
      this.setState({ excelDataList:response.data.Details,excelRequestId:id,excelRequestDate:rdate,excelRequestNo:rno,fileName:rno+'_Checkin',excelRequestUserId:ruser});
      this.setState({ isDownloadExcel:true});
      this.props.setLoading(false);
    }
    }catch(ex){
      this.setState({isDownloadExcel:false,excelDataList:[]});
      this.setState({ isDownloadExcel:true,excelRequestId:id,excelRequestDate:rdate,excelRequestNo:rno,fileName:rno+'_Checkin',excelRequestUserId:ruser});
      this.props.setLoading(false);
    }
  }

  onDownload= async (id,rno,rdate,ruser)=>{
    this.setState({ isDownloadExcel:false});
    this.props.setLoading(true);
    try{
      var response = await api.get(
        `${uri.GET_REQUEST_DETAIL_EXCEL}?id=${id}`
      );
    if(response.status === 200){
      this.setState({ excelDataList:response.data,excelRequestId:id,excelRequestDate:rdate,excelRequestNo:rno,fileName:rno+'_Checkout',excelRequestUserId:ruser});
      this.setState({ isDownloadExcel:true});
      this.props.setLoading(false);
    }
    }catch(ex){
      this.setState({isDownloadExcel:false,excelDataList:[]});
      this.props.setLoading(false);
    }
  }

  downloadExcelForEdit() {
    let filename = 'DOA ' +this.state.fileName;
    let multiDataSet =[{
        columns: [
            {title: "RequestNo", width: {wpx: 90}},
            {title: "RequestID", width: {wpx: 90}},
            {title: "RequestDate", width: {wpx: 90}},
            {title: "RequestUserId", width: {wpx: 90}},
        ],
        data:[
            [
                {value: this.state.excelRequestNo},
                {value: this.state.excelRequestId},
                {value: this.state.excelRequestDate},
                {value: this.state.excelRequestUserId}
            ],
            [
                {value: "ReferenceID", style: {font: {bold: true}}},
                {value: "Action", style: {font: {bold: true}}},
                {value: "Book", style: {font: {bold: true}}},
                {value: "Subject", style: {font: {bold: true}}},
                {value: "SubjectTypeCode", style: {font: {bold: true}}},
                {value: "SubjectType", style: {font: {bold: true}}},
                {value: "TopicNo", style: {font: {bold: true}}},
                {value: "TopicTitle", style: {font: {bold: true}}},
                {value: "ConditionTitle", style: {font: {bold: true}}},
                {value: "Type", style: {font: {bold: true}}},
                {value: "Operation", style: {font: {bold: true}}},
                {value: "Value", style: {font: {bold: true}}},
                {value: "ApproveLevel", style: {font: {bold: true}}},
                {value: "ApproveLevelText", style: {font: {bold: true}}},
                {value: "SignLevel", style: {font: {bold: true}}},
                {value: "SignLevelText", style: {font: {bold: true}}},
                {value: "ReportLevel", style: {font: {bold: true}}},
                {value: "ReportLevelText", style: {font: {bold: true}}},
                {value: "Remark", style: {font: {bold: true}}},
                {value: "Comment", style: {font: {bold: true}}}
            ]
        ]    
    }];
    this.state.excelDataList.map(obj=>{
        let arr = [
            {value:obj.ReferenceID === null?'': obj.ReferenceID},
            {value:obj.Action},
            {value:this.convertNullToStringEmpty(obj.Book)},
            {value:this.convertNullToStringEmpty(obj.SubjectTitle)},
            {value:this.convertNullToStringEmpty(obj.SubjectTypeID)},
            {value:this.convertNullToStringEmpty(obj.SubjectTypeTitle)},
            {value:this.convertNullToStringEmpty(obj.TopicNo)},
            {value:this.convertNullToStringEmpty(obj.TopicTitle)},
            {value:this.convertNullToStringEmpty(obj.ConditionTitle)},
            {value:this.convertNullToStringEmpty(obj.Type)},
            {value:this.convertNullToStringEmpty(obj.Operation)},
            {value:this.convertNullToStringEmpty(obj.Value)},
            {value:this.convertNullToStringEmpty(obj.Approve)},
            {value:this.convertNullToStringEmpty(obj.ApproveText)},
            {value:this.convertNullToStringEmpty(obj.Sign)},
            {value:this.convertNullToStringEmpty(obj.SignText)},
            {value:this.convertNullToStringEmpty(obj.Report)},
            {value:this.convertNullToStringEmpty(obj.ReportText)},
            {value:this.convertNullToStringEmpty(obj.Remark)},
            {value:this.convertNullToStringEmpty(obj.Comment)}
        ];
        multiDataSet[0].data.push(arr);
    });

  return (
    <ExcelFile hideElement={true} filename={filename}>
            <ExcelSheet dataSet={multiDataSet} name="Doa"/>
        </ExcelFile>
  );
}

  onShowSizeChange = (current, pageSize) => {
    this.setState({ currentPage:current });
  }

  render() {
    const indexOfLastPost = this.state.currentPage * this.state.postsPerPage;
    const indexOfFirstPost = indexOfLastPost - this.state.postsPerPage;
    const currentPosts = this.state.dataList.slice(indexOfFirstPost, indexOfLastPost);

    return (
      <div className="home flex-v">
        <SubHeader text={`All Request`} />
          <div className="flex-v flex-1">
            <div className="flex-v flex-1 pl-24 pr-24">
              <div
                className="flex-v bg-grey-lighter pl-16 pr-16 pb-16 mt-16"
                style={{ borderRadius: "10px" }}
              >
                <FormInput
                  value={this.state.requestNo}
                  onValueChange={this.onRequestNoChange}
                  type="text"
                  placeholder="Request No"
                />
                 <FormInput
                    value={this.state.name}
                    onValueChange={this.onNameChange}
                    type="text"
                    placeholder="Name, Email"
                  />
                   <FormSelect
                    value={this.state.status}
                    options={this.state.statusArr}
                    onValueChange={this.onStatusChange}
                  />
                  <div className=" flex-h mt-16 center buttons" >
                      <button onClick={() => this.onSearch()} className="button is-success center" >
                          Search
                      </button>
                      <button onClick={() => this.onConfirmMassUnlock()} className="button is-info center" >
                          Multi Cancel
                      </button>   
                  </div>
              </div>
            </div>
          </div>
        <div className="flex-v text-center p-16 mt-8">
            {this.state.dataList.length === 0 ?<div>Data not found.</div>:
              <div className="table-container">
                <table className="table is-bordered is-striped is-narrow is-hoverable is-fullwidth">
                    <thead>
                        <tr>
                            <th>
                              <input className="ml-8 button-edit-small"  type="checkbox" onChange={(e) => this.handleCheckboxAllChange(e)} checked={this.state.isCheckedAll} />
                            </th>
                            <th>
                                Request No
                            </th>
                            <th style={{width: '150px'}}>
                                Note
                            </th>
                            <th>
                                Status
                            </th>
                            <th>
                                Creator
                            </th>
                            <th style={{width: '100px'}}>
                                Create date
                            </th>
                            <th style={{width: '89px'}}>
                                Expired date
                            </th>
                            <th style={{width: '210px'}}>
                                Detail
                            </th>
                            <th>
                                Action
                            </th>
                            <th style={{width: '70px'}}>
                              History
                            </th>
                        </tr>
                        </thead>
                        <tfoot>
                        <tr>
                            <td colSpan="10" style={{textAlign:'center'}}>
                           
                            <Pagination className="ant-pagination" 
                              onChange={this.onShowSizeChange}
                              defaultCurrent={1} 
                              pageSize={this.state.postsPerPage} 
                              total={this.state.dataList.length} />
                            </td>
                        </tr>
                        </tfoot>
                        <tbody>
                            {currentPosts.map((item, i) =>{
                                return (
                                    <tr key={item.RequestID}>
                                        <td>
                                        {(item.StatusCode !== 'complete' && item.StatusCode !== 'cancel' && item.StatusCode !== 'reject') && 
                                          <input className="ml-8 button-edit-small"  type="checkbox" onChange={(e) => this.handleCheckboxChange(e, item.RequestID)} checked={item.IsChecked} />}
                                        </td>
                                        <td>{item.RequestNo}</td>
                                        <td><span>{item.Note}</span></td>
                                        <td>{item.StatusName}</td>
                                        <td>{item.CreatorName}</td>
                                        <td>{item.CreateDateDisplay}</td>
                                        <td>{item.DisplayExpireDate}</td>
                                        <td>
                                          {item.IsCheckin &&
                                            <div>
                                              <button className="button is-small is-info is-outlined" onClick={() => this.onDetail(item.RequestID)}>View</button>
                                              <button onClick={() => this.onDownloadCheckin(item.RequestID,item.RequestNo,item.CreateDateDisplay,item.CreatorID)} className="button is-small is-default is-outlined ml-8">Download checkin</button>
                                            </div>
                                          }
                                          {/* {(item.StatusCode !== 'create') && 
                                          <button className="button is-small is-info is-outlined" onClick={() => this.onDetail(item.RequestID)}>View</button>}
                                          {(item.StatusCode !== 'create') && 
                                          <button onClick={() => this.onDownloadCheckin(item.RequestID,item.RequestNo,item.CreateDateDisplay,item.CreatorID)} className="button is-small is-default is-outlined ml-8">Download checkin</button>} */}
                                        </td>
                                        <td>
                                          <div>
                                            {(item.StatusCode !== 'complete' && item.StatusCode !== 'cancel' && item.StatusCode !== 'reject') && 
                                            <button onClick={() => this.onConfirmUnlock(item.RequestID)} className="button is-small is-danger is-outlined ml-8">Cancel</button>
                                            }
                                            <button onClick={() => this.onDownload(item.RequestID,item.RequestNo,item.CreateDateDisplay,item.CreatorID)} className="button is-small is-default is-outlined ml-8">Download checkout</button>
                                          </div>
                                        </td>
                                        <td>
                                          <button onClick={() => this.onHistory(item.RequestID)} className="button is-small is-warning is-outlined">View</button>
                                        </td>
                                    </tr>
                                );
                            })}
                        
                    </tbody>
                </table>
              </div>
            }
          
        </div>
        <AlertModal isOpen={this.state.isOpenMessage} message={this.state.message} onClose={this.onClose} type={this.state.type} />
        <ConfirmDialogModal isOpen={this.state.isOpenConfirm} message={this.state.message} onConfirm={this.onUnlock} onClose={this.onClose} text={this.state.text} />
        <HistoryModal isOpen={this.state.isOpenHistory} onClose={this.onClose} datas={this.state.historyList} />
        <ActionModal isOpen={this.state.isOpenAction} action={this.state.action} onClose={this.onClose} actionId={this.state.actionId} onConfirm={this.onConfirmAction}/>
        <RequestDetailModal isOpen={this.state.isOpenDetail} onClose={this.onClose} bookName={this.state.bookName} data={this.state.detailList} permissionList={this.state.permissionList} />
        {this.state.isDownloadExcel && this.downloadExcelForEdit()}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
    user: state.doa.user,
  };
};

export default connect(mapStateToProps, {
  setLoading,
})(SearchRequestForAdmin);
